import { Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "@/lib/theme";

export const ThemeToggle = ({ className = "" }) => {
  const [theme, toggle] = useTheme();
  return (
    <button
      onClick={toggle}
      title={theme === "dark" ? "Switch to light" : "Switch to dark"}
      className={`h-8 w-8 flex items-center justify-center border border-[var(--o-border)] text-[var(--o-muted)] hover:text-[var(--o-fg)] hover:bg-[var(--o-surface)] transition-colors ${className}`}
      data-testid="theme-toggle"
    >
      {theme === "dark" ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
};
